const styles = {
  // semantic delta colors
  positive: { color: 'green', fontWeight: 900 },
  negative: { color: 'red',   fontWeight: 900 },
  neutral:  { color: '#435652' },

  // ===== render ONCE at the very top (under Adjuster) =====
  docsTopLeft: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    fontSize: 13,
    color: '#111',
    marginTop: 6,
    marginBottom: 6,
  },
  docLabel:  { fontWeight: 700, letterSpacing: 0.2 },
  docValue:  { fontWeight: 600 },
  priceList: { color: '#666', fontWeight: 500 },

  keyTop: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 12,
    fontSize: 12,
    color: '#333',
    marginTop: 6,
    marginBottom: 10,
  },
  keyTitle: { fontWeight: 700 },
  keyItem:  { display: 'flex', alignItems: 'center', gap: 4 },
  keyIcon:  { width: 14, height: 14 },

  // ===== per-block =====
  section: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    paddingTop: 8,
    paddingBottom: 18,
    borderBottom: '1px solid #cfcfcf',
  },

  // status bubble on the right
  statusBubble: {
    position: 'absolute',
    right: 6,
    top: 6,
    width: 50,
    height: 50,
  },

  // ===== grids =====
  gridBlock: { display: 'flex', flexDirection: 'column', gap: 0 },

  gridHeadRow: {
    display: 'flex',
    borderTop: '1px solid #ececec',
    borderBottom: '1px solid #ececec',
  },

  // left row-number column
  rowNoHeadSpacer: { width: 28, minWidth: 28 },
  rowNoCell: {
    width: 28,
    minWidth: 28,
    textAlign: 'right',
    paddingRight: 6,
    fontSize: 14,
    color: '#666',
  },

  gridHeadCell: {
    minWidth: 100,
    padding: '4px 8px 2px',
    fontSize: 14,
    fontWeight: 700,
    whiteSpace: 'nowrap',
  },

  gridValRow: { display: 'flex' },
  gridValCell: {
    minWidth: 100,
    padding: '2px 8px 4px',
    fontSize: 14,
    whiteSpace: 'nowrap',
  },

  // alternating fills
  oddCell:  { backgroundColor: '#fff' },
  evenCell: { backgroundColor: '#fff' },

  // ===== per-column ∆ row (3rd row) =====
  deltaRow: {
    display: 'flex',
    borderTop: '1px dotted #9aa3a7',
    marginTop: 2,
    paddingTop: 4,
  },

  // ===== footer: notes | descriptions | zones =====
  footerMetaRow: {
    display: 'grid',
    gridTemplateColumns: '.99fr 1.54fr 1fr', // L / M / R
    gap: 12,
    alignItems: 'start',
    marginTop: 10,
  },
  metaStrong: { fontWeight: 800 },
  metaNotes: { fontSize: 15, lineHeight: 1.3, marginLeft: 0,fontStyle: 'italic'},
  metaDescs: { fontSize: 15, lineHeight: 1.3, marginLeft: 0},
  metaZones: { fontSize: 15, lineHeight: 1.3, marginLeft: 0 },

  // ===== centered money deltas =====
  footerCenteredTrio: {
    display: 'flex',
    justifyContent: 'center',
    gap: 32,
    alignItems: 'baseline',
    marginTop: 8,
    fontWeight: 700,
  },
  trioItem: { display: 'flex', alignItems: 'baseline', gap: 6 },
  trioLabel: { color: '#111', fontSize: 18, letterSpacing: 0.2 },
  trioValue: { fontSize: 18 },

};

export default styles;
